"use strict";

var __importDefault = undefined && undefined.__importDefault || function (mod) {
    return mod && mod.__esModule ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var moment_addon_1 = __importDefault(require("../Addons/moment-addon"));
var FilterCheckBoxSettingsClass_1 = require("../Datatable/FilterCheckBoxSettingsClass");
var absenceInvalid = function absenceInvalid(absence, dateDebut, dateFin) {
    var db = moment_addon_1.default(absence.dateDebut, "YYYY-MM-DDTHH:mm:ss"),
        df = moment_addon_1.default(absence.dateFin, "YYYY-MM-DDTHH:mm:ss");
    return df >= dateDebut && db <= dateFin;
};
var showStateControle = function showStateControle($control, $span, message, isValid) {
    if (isValid) {
        $span.html("");
        $control.removeClass("input-validation-error");
    } else {
        $control.addClass("input-validation-error");
        $span.html("<span id=\"" + $control.attr("id") + "-error\"> " + message + " </span>");
    }
};
//Check on submit
$.fn.checkAbsencesOnSubmit = function () {
    var $target = $(this),
        $dateDebut = $target.find("[name=DateDebut]"),
        $dateFin = $target.find("[name=DateFin]"),
        $span = $target.find("span[data-valmsg-for=DateDebut]");
    showStateControle($dateDebut, $span, "", true);
    if (moment_addon_1.default($dateDebut.val(), "DD/MM/YYYY HH:mm") >= moment_addon_1.default($dateFin.val(), "DD/MM/YYYY HH:mm")) {
        showStateControle($dateDebut, $span, "La date de fin doit être postérieure àla date de début de la période d'absence", false);
        return false;
    }
    return $target.checkAbsenceDelegue() && $target.checkAlreadyAbsent();
};
//Check si déjà absent
$.fn.checkAlreadyAbsent = function () {
    var $target = $(this),
        $select = $target.find("select#DelegueId"),
        $dateDebut = $target.find("[name=DateDebut]"),
        $dateFin = $target.find("[name=DateFin]"),
        $span = $target.find("span[data-valmsg-for=DateDebut]"),
        userAbs = $select.data("userAbsences"),
        absId = $target.find("input:hidden[name=Id]").length > 0 ? $target.find("input:hidden[name=Id]").val() : 0;
    showStateControle($dateDebut, $span, "", true);
    if (userAbs && userAbs.length > 0 && userAbs.filter(function (a) {
        return a.id.toString() !== absId && absenceInvalid(a, moment_addon_1.default($dateDebut.val(), "DD/MM/YYYY HH:mm"), moment_addon_1.default($dateFin.val(), "DD/MM/YYYY HH:mm"));
    }).length !== 0) {
        showStateControle($dateDebut, $span, "Vous avez déjà une absence sur la période choisie", false);
        return false;
    }
    return true;
};
//Check absence délégué
$.fn.checkAbsenceDelegue = function () {
    var $target = $(this);
    if ($target.find("select#DelegueId").length > 0) {
        var $select = $target.find("select#DelegueId"),
            $dateDebut = $target.find("[name=DateDebut]"),
            $dateFin = $target.find("[name=DateFin]"),
            $span = $target.find("span[data-valmsg-for=DelegueId]"),
            datas = $select.data("queryResults") ? $select.data("queryResults").filter(function (d) {
            return d.id === $select.val();
        }) : null;
        showStateControle($select, $span, "", true);
        if (datas) {
            var val = datas[0],
                valid = true;
            if (val && val["absences"] && val["absences"].filter(function (a) {
                return absenceInvalid(a, moment_addon_1.default($dateDebut.val(), "DD/MM/YYYY HH:mm"), moment_addon_1.default($dateFin.val(), "DD/MM/YYYY HH:mm"));
            }).length !== 0) {
                valid = false;
            }
            if (!valid) {
                showStateControle($select, $span, "Ce délégué est absent durant la période choisie", false);
            }
            return valid;
        }
        return true;
    }
    return true;
};
$.fn.initAbsenceModal = function () {
    var $target = $(this);
    if ($target.find("select#DelegueId").length > 0) {
        var $select = $target.find("select#DelegueId"),
            url = $select.data("url");
        $select.select2({
            width: "100%",
            ajax: {
                url: url,
                dataType: "json",
                data: function data(params) {
                    return {
                        term: params.term,
                        idUser: $("input:hidden[name=UserId]").val()
                    };
                },
                processResults: function processResults(data) {
                    $select.data("queryResults", data.results);
                    return { results: data.results };
                }
            }
        }).on("change", function () {
            $target.checkAbsenceDelegue();
        });
        $("body").on("dp.change", "input#DateDebut, input#DateFin", function () {
            $target.checkAbsenceDelegue();
            $target.checkAlreadyAbsent();
        });
        if ($select.val()) {
            $.get($select.data("url") + "?idUser=" + $("input:hidden[name=UserId]").val(), function (data) {
                $select.data("queryResults", data.results);
                $target.checkAbsenceDelegue();
            });
        }
    }
    return $target;
};
$(function () {
    var $gestion = $("div.gestion-absences");
    if ($gestion.length > 0) {
        var $dt = $gestion.find(">.datatable-admin"),
            $th = $dt.find(">table").find(">thead>tr>th"),
            columns = [],
            rowsgroups = [];
        $.map($th, function (e, i) {
            var $e = $(e);
            columns.push({
                name: $e.attr("name"),
                title: $e.text()
            });
            if ($(e).attr("name")) {
                rowsgroups.push(i); //$e.attr("name") + ":name");
            }
        });
        var settings = {
            "drawCallback": function drawCallback(settings) {
                var api = this.api();
                var rows = api.rows({ page: "current" }).nodes();
                var last = null;
                api.column(0, { page: 'current' }).data().each(function (group, i) {
                    if (last !== group) {
                        $(rows).eq(i).before("<tr class=\"group\"><td colspan=\"5\">" + group + "</td></tr>");
                        last = group;
                    }
                });
            }
        };
        $dt.find("table:first").on("preInit.dt", function (e, settings) {
            var filterSettings = new FilterCheckBoxSettingsClass_1.FilterCheckBoxSettings();
            filterSettings.typeFiltre = "exist";
            $dt.addCheckBoxFilter("Juste les absences déclarées", "just-abs", settings, filterSettings);
        });
        $dt.setDatatableAdmin(settings);
        $dt.find("table:first").removeClass("d-none").removeAttr("style");
    }
});


//////////////////
// WEBPACK FOOTER
// ./_wwwsrc/js/Absences/index.ts
// module id = 517
// module chunks = 0